import template from './survey_segments.html';
import tr from '../../../lib/default-translator.js';

class EditSurveySegmentsVM
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.segments = ko.observableArray();
		this.edit_mode = ko.observable(false);
	};

	edit_segment(data)
	{
		this.edit_mode(true);
		data.editing(true);
	};

	async delete_segment(v, e)
	{
		let data = ko.mapping.toJS(v);

		let response = await Grape.alerts.confirm({type: 'warning', title: tr('Confirm'), message: tr('Deleting this segment will also remove all existing survey answers from it. Are you sure you want to delete this segment?')});
		if (response)
		{
			let res = await Grape.fetches.postJSON('/survey/delete_segment', { segment_id: data.segment_id });

			if (res.status == 'OK')
			{
				Grape.alerts.alert({type: 'success', message: tr('Successfully deleted segment'), title: tr('Success', 'Success')});

				if (this.edit_mode() == true)
					this.edit_mode(false);

				this.dialog.updateData();
			}
			else if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			else
				Grape.alerts.alert({type: 'error', message: tr('Something went wrong...', 'Something went wrong...'), title: tr('Error', 'Error')});
		}
	};

	async save_segment(v, e)
	{
		let data = ko.mapping.toJS(v);
		let res = await Grape.fetches.postJSON('/survey/save_segment', data);

		if (res.status == 'OK')
		{
			Grape.alerts.alert({type: 'success', message: tr('Successfully saved segment'), title: tr('Success', 'Success')});
			this.edit_mode(false);
			this.dialog.updateData();
		}
		else if (res.status == 'ERROR')
			Grape.alerts.apiError(res);
		else if (res.error)
			Grape.alerts.alert({type: 'error', message: res.error, title: tr('Error', 'Error')});
		else
			Grape.alerts.alert({type: 'error', message: tr('Something went wrong...', 'Something went wrong...'), title: tr('Error', 'Error')});

		this.edit_mode(false);
	};

	async close()
	{
		this.dialog.close(true);
	}
};

class EditSurveySegmentsPage
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new EditSurveySegmentsVM(this);
		this.name = 'EditSurveySegmentsPage';

		let Segment = function(config)
		{
			let data;
			data = $.extend({
				segment_id: null,
				name: '',
				total_employees: 0
			}, config);

			ko.mapping.fromJS(data, {}, this);
		};

		this.add_segment = (v, e) => {
			this.viewModel.segments.unshift(new Segment({editing: true}));
			this.viewModel.edit_mode(true);
		};
	};

	async init()
	{
		this.updateData();
	};

	async updateData()
	{
		try {
			let option = {
				table: 'segments',
				schema: 'savanna',
				limit: 1000000,
				offset: 0,
				sortorder: 'ASC',
				sortfield: 'segment_id'
			};

			let res = await Grape.fetches.getJSON('/api/record', option)
			if (res.status == 'OK')
			{
				let data = res.records.map(seg => ({
					...seg,
					editing: ko.observable(false)
				}));

				this.viewModel.segments(data);
			}
		} catch (error) {
			console.error(error);
			Grape.alerts.alert({ type: 'error', title: 'Error', message: error.message });
		}
	};
};

export default {
	name: 'EditSurveySegmentsPage',
	dialog_class: EditSurveySegmentsPage,
	template: template,
	template_filename: 'translation/dialogs/survey_segments',
	provider: 'ps'
};
